// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: linear-gradient(135deg, #fdf2f8 0%, #f5eefb 40%, #edf4ff 100%);
}

.main-page-content-wrapper {
  position: absolute;
  top: 60px;
  left: 64px;
  right: 0;
  bottom: 0;
  transition: left 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  background: linear-gradient(135deg, #fdf2f8 0%, #f5eefb 40%, #edf4ff 100%);
}

:host-context(body.crystal-sidebar-pinned) .main-page-content-wrapper {
  left: 304px;
}

ion-content.app-router-content {
  --background: linear-gradient(135deg, #fdf2f8 0%, #f5eefb 40%, #edf4ff 100%);
  height: 100%;
}

@media screen and (max-width: 768px) {
  .main-page-content-wrapper {
    left: 56px;
  }
  :host-context(body.crystal-sidebar-pinned) .main-page-content-wrapper {
    left: 56px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/layout/main-layout/main-layout.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,0EAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,mDAAA;EACA,gBAAA;EACA,0EAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,4EAAA;EACA,YAAA;AACF;;AAEA;EACE;IACE,UAAA;EACF;EAEA;IACE,UAAA;EAAF;AACF","sourcesContent":[":host {\n  display: block;\n  width: 100%;\n  height: 100vh;\n  overflow: hidden;\n  background: linear-gradient(135deg, #fdf2f8 0%, #f5eefb 40%, #edf4ff 100%);\n}\n\n.main-page-content-wrapper {\n  position: absolute;\n  top: 60px;\n  left: 64px;\n  right: 0;\n  bottom: 0;\n  transition: left 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n  overflow: hidden;\n  background: linear-gradient(135deg, #fdf2f8 0%, #f5eefb 40%, #edf4ff 100%);\n}\n\n:host-context(body.crystal-sidebar-pinned) .main-page-content-wrapper {\n  left: 304px;\n}\n\nion-content.app-router-content {\n  --background: linear-gradient(135deg, #fdf2f8 0%, #f5eefb 40%, #edf4ff 100%);\n  height: 100%;\n}\n\n@media screen and (max-width: 768px) {\n  .main-page-content-wrapper {\n    left: 56px;\n  }\n  \n  :host-context(body.crystal-sidebar-pinned) .main-page-content-wrapper {\n    left: 56px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
